<template>
  <AppLink
    to="/"
    class="logo"
  >
    <img
      src="/bagageonline.svg"
      alt=""
      class="logo__image"
      width="328"
      height="61"
    >
  </AppLink>
</template>

<style>
@import url("~layers/app/components/App/Logo.css");
</style>
